// Calling SAR instead of filing. Assuming we will have just SAR s for a while, no need to add nested state until we need to (having a key of sar in this state)
export enum SarActionTypes {
  CREATE_SAR = '@@sars/CREATE_SAR',
  CREATE_SAR_SUCCESS = '@@sars/CREATE_SAR_SUCCESS',

  CREATE_NEW_SAR = '@@sars/CREATE_NEW_SAR',

  ARCHIVE_SAR = '@@sars/ARCHIVE_SAR',
  ARCHIVE_SAR_SUCCESS = '@@sars/ARCHIVE_SAR_SUCCESS',
}

/**
 * @deprecated use SarStatusTypes instead
 */
export enum SarStatus {
  ARCHIVED = 'ARCHIVED',
  PREFILING_VALIDATION_PENDING = 'PREFILING_VALIDATION_PENDING',
  PREFILING_VALIDATION_IN_PROCESS = 'PREFILING_VALIDATION_IN_PROCESS',
  PREFILING_VALIDATION_FAILED = 'PREFILING_VALIDATION_FAILED',
  PREFILING_VALIDATION_SUCCESS = 'PREFILING_VALIDATION_SUCCESS',
  QUEUED_FOR_FILING = 'QUEUED_FOR_FILING',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  SENT_TO_FINCEN = 'SENT_TO_FINCEN',
  SENDING_TO_FINCEN = 'SENDING_TO_FINCEN',
  FILING_FAILED = 'FILING_FAILED',
  FILING_MAX_RETRIES_EXCEEDED = 'FILING_MAX_RETRIES_EXCEEDED',
  FILING_SUCCESS = 'FILING_SUCCESS',
  FINCEN_VALIDATION_FAILED = 'FINCEN_VALIDATION_FAILED',
  FINCEN_REJECTED = 'FINCEN_REJECTED',
  FINCEN_STATUS_OTHER = 'FINCEN_STATUS_OTHER',
  FINCEN_ACCEPTED = 'FINCEN_ACCEPTED',
}

export enum FincenSarTablePages {
  REPORT_FILING = 'REPORT_FILING',
  QUEUE_DETAILS = 'QUEUE_DETAILS',
  MY_FILINGS = 'MY_FILINGS',
  QUEUED_FILINGS = 'QUEUED_FILINGS',
  QUALITY_CYCLE_SARS = 'QUALITY_CYCLE_SARS',
  REPORT_DASHBOARDS = 'REPORT_DASHBOARDS',
  FILING_AI_AGENT_FILING_HISTORY = 'FILING_AI_AGENT_FILING_HISTORY',
}
